/**
 * Llamadas al catalogo publico.
 *
 * Cada funcion corresponde a un endpoint y a una pantalla: la firma dice que
 * necesita la vista, y el tipo de retorno sale del paquete compartido, o sea es
 * exactamente lo que el backend promete devolver.
 */
import type {
  ArbolNavegacion,
  ContenidoInicio,
  FichaProducto,
  OrdenCatalogo,
  PaginaCategoria,
  PaginaLinea,
  ProductoResumen,
  ProductosVigentesDto,
} from '@bandu/compartido';

import { pedir } from './cliente-api';

export interface OpcionesListado {
  pagina?: number;
  orden?: OrdenCatalogo;
  senal?: AbortSignal;
}

function parametrosDe(opciones: OpcionesListado): Record<string, string | number | undefined> {
  return { pagina: opciones.pagina, orden: opciones.orden };
}

export function obtenerNavegacion(senal?: AbortSignal): Promise<ArbolNavegacion> {
  return pedir<ArbolNavegacion>('/catalogo/navegacion', { ...(senal ? { senal } : {}) });
}

export function obtenerInicio(senal?: AbortSignal): Promise<ContenidoInicio> {
  return pedir<ContenidoInicio>('/catalogo/inicio', { ...(senal ? { senal } : {}) });
}

export function obtenerFichaProducto(slug: string, senal?: AbortSignal): Promise<FichaProducto> {
  return pedir<FichaProducto>(`/catalogo/productos/${slug}`, { ...(senal ? { senal } : {}) });
}

export function obtenerCategoria(
  slug: string,
  opciones: OpcionesListado = {},
): Promise<PaginaCategoria> {
  return pedir<PaginaCategoria>(`/catalogo/categorias/${slug}`, {
    parametros: parametrosDe(opciones),
    ...(opciones.senal ? { senal: opciones.senal } : {}),
  });
}

export function obtenerLinea(slug: string, opciones: OpcionesListado = {}): Promise<PaginaLinea> {
  return pedir<PaginaLinea>(`/catalogo/lineas/${slug}`, {
    parametros: parametrosDe(opciones),
    ...(opciones.senal ? { senal: opciones.senal } : {}),
  });
}

/**
 * De los SKU guardados en el carro, cuales siguen publicados (CHK-02).
 *
 * Aca se descarta lo que ya no existe y
 * se refresca precio, stock y foto. La disponibilidad de verdad se comprueba
 * una sola vez, al momento de cobrar (CHK-05).
 */
export function obtenerProductosVigentes(
  skus: string[],
  senal?: AbortSignal,
): Promise<ProductoResumen[]> {
  const cuerpo: ProductosVigentesDto = { skus };

  return pedir<ProductoResumen[]>('/catalogo/productos/vigentes', {
    metodo: 'POST',
    cuerpo,
    ...(senal ? { senal } : {}),
  });
}
